var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-col",
    { staticClass: "grid-col" },
    [
      _c("el-card", { staticClass: "grid-card", attrs: { shadow: "hover" } }, [
        _c("div", { staticStyle: { padding: "0 10px 10px 10px" } }, [
          _c(
            "div",
            [
              _c(
                "el-checkbox",
                { attrs: { label: _vm.item.id, indeterminate: false } },
                [_c("br")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "grid-card-title" }, [
            _c("div", { staticClass: "icon", class: _vm.item.icon + "-black" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "grid-name" },
              [
                _vm.isFlag < 1
                  ? _c(
                      "div",
                      {
                        attrs: { name: "listTaskName", title: _vm.item.name },
                        on: {
                          click: function($event) {
                            return _vm.editTaskListName(_vm.item)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.item.name))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isFlag > 0
                  ? _c("el-input", {
                      ref: "listInputName",
                      staticClass: "grid-card-edit",
                      attrs: {
                        disabled: _vm.isFlag == 1,
                        type: "textarea",
                        autosize: { minRows: 1, maxRows: 2 },
                        resize: "none"
                      },
                      on: {
                        blur: function($event) {
                          return _vm.submitTaskListName(_vm.item)
                        }
                      },
                      nativeOn: {
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.enterEvent(_vm.item, $event)
                        }
                      },
                      model: {
                        value: _vm.showTaskName,
                        callback: function($$v) {
                          _vm.showTaskName = $$v
                        },
                        expression: "showTaskName"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "grid-schdule" },
            [
              _vm.isShowSchdule(_vm.item)
                ? _c("tabTaskSchdule", {
                    ref: "tabTaskSchdule",
                    attrs: { task: _vm.item },
                    on: {
                      update: _vm.clickScheduleBtn,
                      "open-popup": _vm.openFunctionPopup
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "grid-route" }, [
            _vm.item.fromItem
              ? _c("div", { staticClass: "grid-route-item" }, [
                  _vm.item.fromItem.icons.length > 1
                    ? _c(
                        "div",
                        {
                          staticClass: "task-icon-multi",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.openFunctionPopup(8)
                            }
                          }
                        },
                        [
                          _vm._l(_vm.item.fromItem.icons.slice(0, 4), function(
                            fromItem,
                            index
                          ) {
                            return _c("div", {
                              key: index,
                              staticClass: "clouds_logo clouds_logo_30",
                              class: fromItem.driveType,
                              style:
                                _vm.item.fromItem.icons.length == 3 &&
                                index == 0
                                  ? "margin: 0 15px;"
                                  : ""
                            })
                          }),
                          _vm._v(" "),
                          _vm.item.fromItem.icons.length > 4 &&
                          _vm.item.fromItem.icons.length < 10
                            ? _c(
                                "div",
                                { staticClass: "task-icon-multi-more" },
                                [_vm._v(_vm._s(_vm.item.fromItem.icons.length))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.item.fromItem.icons.length > 9
                            ? _c(
                                "div",
                                { staticClass: "task-icon-multi-more" },
                                [_vm._v("9+")]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    : _c("div", {
                        staticClass: "task-icon clouds_logo clouds_logo_60",
                        class: _vm.item.fromItem.icons[0].driveType,
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.toSourceCatalog(_vm.item)
                          }
                        }
                      }),
                  _vm._v(" "),
                  _c("div", { staticClass: "grid-route-name" }, [
                    _vm.item.fromItem.icons.length > 1
                      ? _c(
                          "span",
                          {
                            attrs: {
                              title: _vm.getCatalog(
                                _vm.item.fromItem.lists[0].nodes
                              )
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.openFunctionPopup(8)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("language.taskList.multiClouds"))
                            )
                          ]
                        )
                      : _c("span", [
                          _vm.item.fromItem.lists[0].driveType == "offlinesTask"
                            ? _c(
                                "span",
                                {
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.copyLink(
                                        _vm.item.fromItem.lists[0].name
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t("language.common.copyLink")
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            : _c(
                                "span",
                                {
                                  attrs: {
                                    title: _vm.getCatalog(
                                      _vm.item.fromItem.lists[0].nodes
                                    )
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.toSourceCatalog(_vm.item)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getNewCloudName(
                                        _vm.item.fromItem.lists[0]
                                      )
                                    )
                                  )
                                ]
                              )
                        ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            (_vm.item.type == 2 &&
              _vm.item.options &&
              _vm.item.options.way == "20") ||
            (_vm.item.type == 1 &&
              _vm.item.options &&
              _vm.item.options.isRemove == "1")
              ? _c("div", { staticClass: "sync_arrow" })
              : _c("div", { staticClass: "double_arrow" }),
            _vm._v(" "),
            _vm.item.toItem
              ? _c("div", { staticClass: "grid-route-item" }, [
                  _vm.item.toItem.icons.length > 1
                    ? _c(
                        "div",
                        {
                          staticClass: "task-icon-multi",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.openFunctionPopup(8)
                            }
                          }
                        },
                        [
                          _vm._l(_vm.item.toItem.icons.slice(0, 4), function(
                            toItem,
                            index
                          ) {
                            return _c("div", {
                              key: index,
                              staticClass: "clouds_logo clouds_logo_30",
                              class: toItem.driveType,
                              style:
                                _vm.item.toItem.icons.length == 3 && index == 0
                                  ? "margin: 0 15px;"
                                  : ""
                            })
                          }),
                          _vm._v(" "),
                          _vm.item.toItem.icons.length > 4 &&
                          _vm.item.toItem.icons.length < 10
                            ? _c(
                                "div",
                                { staticClass: "task-icon-multi-more" },
                                [_vm._v(_vm._s(_vm.item.toItem.icons.length))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.item.toItem.icons.length > 9
                            ? _c(
                                "div",
                                { staticClass: "task-icon-multi-more" },
                                [_vm._v("9+")]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    : _c("div", {
                        staticClass: "task-icon clouds_logo clouds_logo_60",
                        class: _vm.item.toItem.icons[0].driveType,
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.toAimCatalog(_vm.item)
                          }
                        }
                      }),
                  _vm._v(" "),
                  _c("div", { staticClass: "grid-route-name" }, [
                    _vm.item.toItem.icons.length > 1
                      ? _c(
                          "span",
                          {
                            attrs: {
                              title: _vm.getCatalog(
                                _vm.item.toItem.lists[0].nodes
                              )
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.openFunctionPopup(8)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("language.taskList.multiClouds"))
                            )
                          ]
                        )
                      : _c(
                          "span",
                          {
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.toAimCatalog(_vm.item)
                              }
                            }
                          },
                          [
                            _vm.item.type == 6 &&
                            (_vm.item.tranferWay == "restore" ||
                              _vm.item.tranferWay == "retry-restore") &&
                            (_vm.item.status == 1 || _vm.item.status == 2) &&
                            !_vm.item.isRestoreNew
                              ? _c("span", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t("language.cloudBackup.original")
                                      ) +
                                      "\n                            "
                                  )
                                ])
                              : _c(
                                  "span",
                                  {
                                    attrs: {
                                      title: _vm.getCatalog(
                                        _vm.item.toItem.lists[0].nodes
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getNewCloudName(
                                          _vm.item.toItem.lists[0]
                                        )
                                      )
                                    )
                                  ]
                                )
                          ]
                        )
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "grid-function",
              on: {
                mouseleave: function($event) {
                  return _vm.changeOptionMenu(false)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "grid-state" },
                [
                  _c("tabTaskStatus", {
                    ref: "tabTaskStatus",
                    attrs: { task: _vm.item },
                    on: { "open-popup": _vm.openFunctionPopup }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "grid-btns" },
                [
                  _c("tabTaskOption", {
                    ref: "tabTaskOption",
                    attrs: { task: _vm.item },
                    on: {
                      "open-popup": _vm.openFunctionPopup,
                      update: _vm.clickButton
                    }
                  })
                ],
                1
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-971be64e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-971be64e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_task_list/tabs_single_task_card.vue
// module id = null
// module chunks = 